module.exports = __webpack_public_path__ + "media/images/landing_page/2023/webpage/majaslapa-sakumlapa-82255bd287786670324ea6b91e59c1da.webp";